import styled, { keyframes, css } from "styled-components";
import { Loader2 } from "lucide-react";
import { device } from "../../../atoms/Utlis/media";

export const gradient = "linear-gradient(144.01deg, #ffc951 0%, #c94daa 130%)";

export const C2CPageContainer = styled.div`
  width: 100%;
  padding: 24px;
  font-family: Urbanist, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-shrink: 0;
  box-sizing: border-box;
  @media ${device.tablet} {
    padding: 16px;
  }
`;

export const Hero = styled.div`
  position: relative;
  overflow: visible;
  flex-shrink: 0;
  border-radius: 20px;
  padding: 24px 26px;
  background: linear-gradient(
    135deg,
    rgba(255, 201, 81, 0.16) 0%,
    rgba(206, 86, 176, 0.12) 55%,
    rgba(14, 165, 233, 0.08) 100%
  );
  border: 1px solid rgba(201, 77, 170, 0.12);
  box-shadow: 0 8px 28px rgba(201, 77, 170, 0.08);
`;

export const HeroGlow = styled.div`
  pointer-events: none;
  position: absolute;
  top: -80px;
  right: -4%;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(14, 165, 233, 0.22) 0%, transparent 70%);
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeroText = styled.div`
  min-width: 0;
`;

export const HeroBadge = styled.span`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  padding: 5px 11px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(201, 77, 170, 0.14);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #c94daa;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
  padding: 2px 0;
`;

export const PageSubtitle = styled.p`
  margin: 0px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.62);
  max-width: 560px;
`;

export const SummaryStatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const WalletHero = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  color: #fff;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  box-shadow: 0 8px 22px rgba(201, 77, 170, 0.22);
  text-align: left;

  &::after {
    content: "";
    position: absolute;
    right: -20px;
    bottom: -24px;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
  }
`;

export const WalletIconWrap = styled.div`
  position: relative;
  z-index: 1;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.22);
`;

export const WalletHeroBody = styled.div`
  position: relative;
  z-index: 1;
  min-width: 0;
`;

export const WalletHeroValue = styled.div`
  font-family: Urbanist, sans-serif;
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  line-height: 1.1;
`;

export const WalletHeroLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  margin-top: 2px;
`;

export const StatCard = styled.div<{ $tone: string }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 6px 18px rgba(23, 23, 23, 0.04);
`;

export const StatIcon = styled.div<{ $tone: string }>`
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(p) => p.$tone};
  background: ${(p) => `${p.$tone}18`};
`;

export const StatBody = styled.div`
  min-width: 0;
`;

export const StatValue = styled.div`
  font-family: Urbanist, sans-serif;
  font-size: 20px;
  font-weight: 800;
  color: #171717;
  line-height: 1.1;
`;

export const StatLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
  margin-top: 2px;
`;

export const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;



export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  flex-shrink: 0;
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 800;
  margin: 0;
  color: #171717;
`;

export const CountPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
`;

export const PrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 42px;
  padding: 0 18px;
  border: none;
  border-radius: 12px;
  background: ${gradient};
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 8px 20px rgba(201, 77, 170, 0.24);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 24px rgba(201, 77, 170, 0.32);
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const SecondaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid rgba(23, 23, 23, 0.14);
  border-radius: 9px;
  background: white;
  color: rgba(23, 23, 23, 0.75);
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
  &:hover:not(:disabled) {
    background: #f5f7fa;
  }
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const DangerBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid rgba(239, 68, 68, 0.25);
  border-radius: 9px;
  background: white;
  color: #ef4444;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
  &:hover:not(:disabled) {
    background: #fef2f2;
  }
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const CopyBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  border-radius: 7px;
  background: white;
  color: rgba(23, 23, 23, 0.6);
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
  &:hover {
    background: #f5f7fa;
  }
`;

export const SessionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
  flex-shrink: 0;
`;

export const SessionCard = styled.div<{ $expired: boolean }>`
  position: relative;
  background: white;
  border: 1px solid ${(p) => (p.$expired ? "rgba(107, 114, 128, 0.2)" : "rgba(23, 23, 23, 0.06)")};
  border-radius: 18px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(23, 23, 23, 0.05);
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow: visible;
  opacity: ${(p) => (p.$expired ? 0.9 : 1)};
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;

  &:hover {
    border-color: ${(p) =>
      p.$expired ? "rgba(107, 114, 128, 0.28)" : "rgba(201, 77, 170, 0.22)"};
    box-shadow: 0 14px 34px rgba(23, 23, 23, 0.08);
    transform: translateY(-2px);
  }
`;

export const ExpiredOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  margin: -20px -20px 0;
  padding: 10px 16px;
  background: rgba(107, 114, 128, 0.1);
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #6b7280;
  border-bottom: 1px solid rgba(107, 114, 128, 0.14);
  border-radius: 18px 18px 0 0;
`;

export const ExpiryWarning = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.25);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #d97706;
  animation: ${pulse} 2s ease infinite;
`;

export const CardTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const DeviceIconWrap = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: linear-gradient(144deg, rgba(255, 201, 81, 0.2), rgba(201, 77, 170, 0.14));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardMeta = styled.div`
  flex: 1;
  min-width: 0;
`;

export const DeviceName = styled.div`
  font-size: 15px;
  font-weight: 800;
  color: #171717;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DeviceBrand = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: rgba(23, 23, 23, 0.5);
  margin-top: 2px;
`;

export const ConnTypeBadge = styled.div`
  height: 22px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 100px;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
`;

export const CardTools = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const AlbumRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 10px;
  row-gap: 6px;
  align-items: center;
  padding: 14px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid rgba(23, 23, 23, 0.05);
`;

export const AlbumLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.4);
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
`;

export const AlbumValue = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #171717;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChangeDestinationBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(201, 77, 170, 0.08);
  border: 1px solid rgba(201, 77, 170, 0.18);
  color: #c94daa;
  font-family: Urbanist, sans-serif;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 8px;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(201, 77, 170, 0.16);
    border-color: rgba(201, 77, 170, 0.3);
    color: #a8328c;
    transform: translateY(-1px);
  }
`;

export const EditSessionBtn = ChangeDestinationBtn;


export const PanelDestinationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 10px 14px;
  background: linear-gradient(135deg, rgba(255, 201, 81, 0.08) 0%, rgba(206, 86, 176, 0.05) 100%);
  border: 1px solid rgba(201, 77, 170, 0.12);
  border-radius: 10px;
`;

export const PanelDestinationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #171717;
  min-width: 0;

  span {
    color: rgba(23, 23, 23, 0.5);
    font-weight: 500;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
  }
`;

export const StatsRow = styled.div`

  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const StatChip = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 100px;
  background: ${(p) => p.$color}18;
  color: ${(p) => p.$color};
  font-size: 12px;
  font-weight: 700;
`;

export const LoadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 40px 0;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  color: rgba(23, 23, 23, 0.5);
`;

export const Spinner = styled(Loader2)`
  animation: ${spin} 0.8s linear infinite;
  color: #c94daa;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 60px 24px;
  text-align: center;
  background: white;
  border: 1px dashed rgba(23, 23, 23, 0.12);
  border-radius: 16px;
  margin-bottom: 32px;
  animation: ${fadeUp} 0.4s ease;
`;

export const EmptyTitle = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #171717;
`;

export const EmptyDesc = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: rgba(23, 23, 23, 0.55);
  max-width: 380px;
  line-height: 1.6;
`;

export const DisabledBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 80px 24px;
  text-align: center;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(201, 77, 170, 0.06) 0%, rgba(255, 201, 81, 0.04) 100%);
  border: 1px solid rgba(201, 77, 170, 0.12);
`;

export const DisabledTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #171717;
`;

export const DisabledDesc = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  color: rgba(23, 23, 23, 0.6);
  max-width: 440px;
  line-height: 1.7;
`;

export const UploadPanel = styled.div`
  background: white;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 10px 28px rgba(23, 23, 23, 0.05);
  animation: ${fadeUp} 0.35s ease;
  margin-bottom: 32px;
`;

export const UploadPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 20px;
`;

export const UploadStatsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 18px;
  padding: 12px 14px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.05);
  border-radius: 8px;
`;

export const PollingBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.4);
  font-family: Montserrat, sans-serif;
  animation: ${pulse} 2s ease infinite;
`;

export const ExpiryInfo = styled.span<{ $warning: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => (p.$warning ? "#d97706" : "rgba(23,23,23,0.45)")};
  font-family: Montserrat, sans-serif;
`;

export const PollErrorBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #fafafa;
  border: 1px solid rgba(107, 114, 128, 0.18);
  border-radius: 8px;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
`;

export const EmptyUploads = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-height: 220px;
  padding: 44px 24px;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: rgba(23, 23, 23, 0.5);
  text-align: center;
  background: #ffffff;
  border: 1px dashed rgba(23, 23, 23, 0.12);
  border-radius: 8px;
`;

export const UploadTableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid rgba(23, 23, 23, 0.07);
  border-radius: 8px;
  background: #ffffff;
`;

export const UploadTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 760px;
`;

export const Th = styled.th`
  text-align: left;
  padding: 12px 14px;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: rgba(23, 23, 23, 0.4);
  background: #fafafa;
  border-bottom: 1px solid rgba(23, 23, 23, 0.07);
`;

export const Tr = styled.tr`
  &:hover {
    background: #f9fafb;
  }
`;

export const Td = styled.td`
  padding: 12px 14px;
  color: #171717;
  border-bottom: 1px solid rgba(23, 23, 23, 0.05);
  vertical-align: middle;
`;

export const statusColors: Record<string, string> = {
  success: "#16a34a",
  failed: "#ef4444",
  duplicate: "#f09a3e",
};

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-block;
  padding: 2px 9px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  background: ${(p) => (statusColors[p.$status] || "#6b7280") + "18"};
  color: ${(p) => statusColors[p.$status] || "#6b7280"};
  text-transform: capitalize;
`;

export const MediaIdChip = styled.span`
  font-size: 12px;
  font-weight: 600;
  background: rgba(124, 77, 255, 0.08);
  color: #7c4dff;
  padding: 2px 8px;
  border-radius: 6px;
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 18px;
`;

export const PageLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.6);
`;

export const RevokeSection = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(23, 23, 23, 0.06);
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(23, 23, 23, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
`;

export const Modal = styled.div`
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 24px 80px rgba(23, 23, 23, 0.22);
  animation: ${fadeUp} 0.28s ease;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  padding: 24px 24px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #171717;
`;

export const SessionBadge = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
`;

export const ModalBody = styled.div`
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalFooter = styled.div`
  padding: 0 24px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 12px;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const Label = styled.label`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const inputBase = css<{ $hasError?: boolean }>`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid ${(p) => (p.$hasError ? "#ef4444" : "rgba(23,23,23,0.12)")};
  border-radius: 9px;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #171717;
  background: white;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
  &:focus {
    border-color: ${(p) => (p.$hasError ? "#ef4444" : "#c94daa")};
  }
  &:disabled {
    background: #f9fafb;
    color: rgba(23, 23, 23, 0.35);
  }
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  ${inputBase}
`;

export const Select = styled.select<{ $hasError?: boolean }>`
  ${inputBase}
  appearance: none;
  cursor: pointer;
  padding-right: 32px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23171717' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
`;

export const FieldError = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #ef4444;
`;

export const ConnTypePill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 10px;
  background: rgba(201, 77, 170, 0.08);
  border: 1.5px solid rgba(201, 77, 170, 0.25);
  color: #c94daa;
  font-size: 14px;
  font-weight: 700;
  width: fit-content;
`;

export const CredWarningBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  background: rgba(245, 158, 11, 0.1);
  border-bottom: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 20px 20px 0 0;
  font-size: 13px;
  font-weight: 700;
  color: #b45309;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const CredTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const CredRow = styled.tr`
  border-bottom: 1px solid rgba(23, 23, 23, 0.05);
  &:last-child {
    border-bottom: none;
  }
`;

export const CredLabel = styled.td`
  padding: 10px 8px 10px 0;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  width: 100px;
  vertical-align: middle;
`;

export const CredValueCell = styled.td`
  padding: 8px;
  vertical-align: middle;
`;

export const CredValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #171717;
  font-family: "Courier New", monospace;
  margin-bottom: 4px;
`;

export const CredSetting = styled.td`
  padding: 8px 0 8px 8px;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: rgba(23, 23, 23, 0.4);
  vertical-align: middle;
`;

export const GuideNote = styled.div`
  padding: 12px 14px;
  background: #f3f4f6;
  border-radius: 8px;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: rgba(23, 23, 23, 0.65);
  line-height: 1.6;
`;
